import React from 'react';
//import {Link} from 'react-router-dom';
import Icon from './Icon';
import createLink from "../../libs/createLink";
import history from "../../libs/history";

const replaceTitleByHash = (title) =>{
    if(title){
        if(title.charAt(0) === "#"){
            title = title.slice(1);
        }
        title = title.charAt(0).toUpperCase() + title.slice(1);
        let re = new RegExp(/([ |\-|_]+)/, 'g');
        title = title.replace(re, '');
        title = `#${title}`;
    }
    return title;
}

const TagList = (props) => {
    return (
        <div className={`tag-list row wrap ${props.className}`}>
            {props.tags && props.tags.map((tag, index) => {
                tag.title = replaceTitleByHash(tag.title);
                let link  = createLink(props.type ? props.type : "", {tag : tag, slug : props.owner && props.owner.slug});
                return(
                <div className="tag" key={index}>
                    {/*tag.slug && tag.slug !== '' ?
                        <Link to={link} key={index}>
                            {tag.title}
                        </Link>
                        :
                        <div key={index}>
                            {tag.slug && tag.slug !== '' ?
                                <Link to={link} key={index}>{tag.title}</Link> :
                                <div key={index}>{tag.title}</div>}
                        </div>
                    */}
                    <div key={index}>
                        {tag.slug && tag.slug !== '' ?
                            <div className={"cursor-pointer"} onClick={()=>history.push(link)} key={index}>{tag.title}</div> :
                            <div key={index}>{tag.title}</div>}
                    </div>
                    {typeof (props.removeTags) != "undefined" && (
                        <span onClick={() => props.removeTags(index, tag._id)}><Icon type="close"/></span>)}
                    {props.type === "addTags" && (
                        <span onClick={() => props.addTags(index, tag._id)}><Icon type="plus"/></span>)}
                </div>
            )})}
        </div>
    )
};
export default TagList;
